import {
  CheckboxFormField,
  CountrySelectField,
  FormSection,
  GridContainer,
  GridItem,
  InputFormField,
} from "@duosoftbg/nacid-components";
import React, { useEffect, useMemo } from "react";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { countriesDataThunk } from "../../../../../../store/redux/slice/AppData/countriesData";
import { useFormContext, useWatch } from "react-hook-form";

const useFilteredCountries = (excludeId) => {
  const countriesState = useAppSelector((state) => state.AppData.CountriesData);

  return useMemo(() => {
    if (!countriesState?.data) return countriesState;
    return {
      ...countriesState,
      data: countriesState.data.filter((country) => country.id !== excludeId),
    };
  }, [countriesState, excludeId]);
};

const SecondarySchoolFormSection = ({ foreignGradingScaleCountry = true }) => {
  return (
    <FormSection label={"t.secondary.school.details"}>
      <GridContainer spacing={3}>
        <GridItem sm={4} md={4}>
          <GradingScaleCountryFormField />
        </GridItem>
        <GridItem sm={4} md={4}>
          <InputFormField required={true} fieldName={"schoolSettlement"} labelCode={"l.schoolSettlement"} />
        </GridItem>
        <GridItem sm={4} md={4}>
          <InputFormField required={true} fieldName={"schoolName"} labelCode={"l.schoolName"} />
        </GridItem>
      </GridContainer>
      {foreignGradingScaleCountry && <ForeignGradingScaleCountryFormSubsection />}
    </FormSection>
  );
};

const ForeignGradingScaleCountryFormSubsection = () => {
  const schoolCountry = useWatch({ name: "schoolCountry" });

  return (
    <>
      <GridContainer spacing={3} mt={0}>
        <GridItem sm={12} md={12}>
          <CheckboxFormField
            fieldName={"isForeignGradingScale"}
            labelCode={"l.isForeignGradingScale"}
            isDisabled={schoolCountry?.id === "BG"}
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem sm={4} md={4}>
          <SchoolGradingScaleCountryFormField />
        </GridItem>
      </GridContainer>
    </>
  );
};

const GradingScaleCountryFormField = () => {
  const filteredCountries = useFilteredCountries(undefined);

  return (
    <CountrySelectField
      countryRequired={true}
      countryField={`schoolCountry`}
      countryLabel={"l.schoolCountry"}
      countriesThunkState={filteredCountries}
      countriesThunk={countriesDataThunk}
    />
  );
};

const SchoolGradingScaleCountryFormField = () => {
  const isForeignGradingScale = useWatch({ name: "isForeignGradingScale" });
  const schoolCountry = useWatch({ name: "schoolCountry" });

  const { setValue } = useFormContext();

  useEffect(() => {
    if (schoolCountry?.id === "BG") {
      setValue("isForeignGradingScale", true);
    }

    if (!isForeignGradingScale && schoolCountry?.id !== "BG") {
      setValue("schoolGradingScaleCountry", schoolCountry);
    }
  }, [isForeignGradingScale, schoolCountry, setValue]);

  const filteredCountries = useFilteredCountries("BG");

  const extendedCountriesState = useMemo(() => {
    if (!filteredCountries?.data) return filteredCountries;
    return {
      ...filteredCountries,
      data: [
        { id: "IB", name: "International Baccalaureate" },
        { id: "EB", name: "European Baccalaureate" },
        ...filteredCountries.data,
      ],
    };
  }, [filteredCountries]);

  return (
    <CountrySelectField
      countryRequired={true}
      countryField={"schoolGradingScaleCountry"}
      countryLabel={"l.schoolGradingScaleCountry"}
      disabled={!isForeignGradingScale}
      countriesThunkState={extendedCountriesState}
      countriesThunk={countriesDataThunk}
    />
  );
};

export default SecondarySchoolFormSection;
